import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import { moneyFormat } from '../../../../../parts/common/moneyFormat';

import ConfirmationTicketList_en from './locales/ConfirmationTicketList_en.json';
import ConfirmationTicketList_fr from './locales/ConfirmationTicketList_fr.json';

class ConfirmationTicketList extends React.PureComponent {
  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'ConfirmationTicketList', ConfirmationTicketList_en);
    i18next.addResourceBundle('fr', 'ConfirmationTicketList', ConfirmationTicketList_fr);
  }

  getTicketPrice = (ticketId, ticketList) => {
    return ticketList
      .filter(ticket => ticket.id === ticketId)
      .map(ticket => ticket.totalPrice)[0] || 0;
  };

  getTicketName = (ticketId, ticketList) => {
    return ticketList
      .filter(ticket => ticket.id === ticketId)
      .map(ticket => ticket.description && ticket.description.name || [])[0] || '';
  };

  render() {
    const { t, locale, tickets, ticketList } = this.props;

    return (
      <>
        {(tickets && ticketList) &&
          tickets.map(ticket => (
            <tbody key={ticket.id} className="ticket">
              <tr>
                <td>
                  <label>{t('label.ticket')}</label>
                </td>
                <td>{this.getTicketName(ticket.ticketId, ticketList)}</td>
              </tr>
              <tr>
                <td>
                  <label>{t('label.quantity')}</label>
                </td>
                <td>{ticket.quantity}</td>
              </tr>
              <tr>
                <td>
                  <label>{t('label.unit-price')}</label>
                </td>
                <td>{moneyFormat(this.getTicketPrice(ticket.ticketId, ticketList), locale)}</td>
              </tr>
              <tr>
                <td>
                  <label>{t('label.total-price')}</label>
                </td>
                <td>{moneyFormat(this.getTicketPrice(ticket.ticketId, ticketList) * ticket.quantity, locale)}</td>
              </tr>
            </tbody>
          )
        )}
      </>
    );
  }
}

ConfirmationTicketList.propTypes = {
  tickets: PropTypes.array,
  ticketList: PropTypes.array
};

export default translate('ConfirmationTicketList')(ConfirmationTicketList);
